import { useSelector } from 'react-redux';

import {
  billingAppCreditsSelector,
  billingAppDetailsSelector,
} from '@redux/selectors/billings-app.selectors';
import { isAppRealm, isConciergeRealm, isPublisherRealm } from '@utils/realmIdentifier';
import { billingConciergeDetailsSelector } from '@redux/selectors/billings-concierge.selectors';
import { billingPublisherDetailsSelector } from '@redux/selectors/billings-publisher.selectors';
import loadingStatuses from '@constants/loadingStatuses';

/**
 * Returns `true` when the current realm is Concierge
 * OR the billing status retrieved from Redux is active.
 *
 * Usage:
 *   const isActiveBilling = useActiveBilling();
 */
export function useActiveBilling(): boolean {
  const { data } = useSelector(billingAppDetailsSelector);
  return isConciergeRealm() || isPublisherRealm() || Boolean(data?.active);
}

export function useBillingLoadingStatus(): string {
  const { loadingStatus: billingAppLs } = useSelector(billingAppCreditsSelector);
  const { loadingStatus: billingConciergeLs } = useSelector(billingConciergeDetailsSelector);
  const { loadingStatus: billingPublisherLs } = useSelector(billingPublisherDetailsSelector);
  if (isAppRealm()) {
    return billingAppLs;
  }
  if (isConciergeRealm()) {
    return billingConciergeLs;
  }
  if (isPublisherRealm()) {
    return billingPublisherLs;
  }
  return loadingStatuses.PENDING;
}
